import { render, staticRenderFns } from "./TrademarkRegister.vue?vue&type=template&id=85c9843e&scoped=true"
import script from "./TrademarkRegister.vue?vue&type=script&lang=js"
export * from "./TrademarkRegister.vue?vue&type=script&lang=js"
import style0 from "./TrademarkRegister.vue?vue&type=style&index=0&id=85c9843e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c9843e",
  null
  
)

export default component.exports